import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "./lib/analytics";

initAnalytics();

// The prerender step (scripts/prerender.ts) bakes each route's fully
// rendered HTML into #root so crawlers see real content. That's a plain
// static snapshot, not a hydration boundary — createRoot() is not
// guaranteed to clear pre-existing children before its first commit, and
// in practice left stray duplicated nodes (e.g. some ScrollReveal-wrapped
// sections rendering twice) when mounting on top of that snapshot.
// Clearing the container first guarantees a clean, single render.
const rootContainer = document.getElementById("root")!;
rootContainer.innerHTML = "";

createRoot(rootContainer).render(<App />);
